import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Typography from '../../../../componentsv2/Typography';
import Button from '../../../../componentsv2/Button';
import { useTranslation } from '../../../../hooks/i18n';
import { DASHBOARD } from '../../../../constants/auth';
import { COLORS } from '../../../../themev2';

const Step4GetHelpFromMarco = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goBackToLogin = () => {
    navigate(DASHBOARD);
  };

  return (
    <Grid container rowSpacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ fontWeight: 600, textAlign: 'center' }}>
          {t('common:twoFactor.getHelpFromMarcoTitle')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            color: COLORS.gray[1100],
            size: '18px',
            fontWeight: 400,
          }}
        >
          <Trans
            i18nKey="common:twoFactor.getHelpFromMarcoDescription"
            components={[<a href={`mailto:${t('common:register.supportEmail')}`}>Customer Support Team</a>]}
          />
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ marginTop: '4rem' }}>
        <Button fullWidth color="secondary" onClick={goBackToLogin}>
          {t('common:twoFactor.backToDashboard')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default Step4GetHelpFromMarco;
